import { usePlanFeatureAccessContext } from '../services/Contexts/PlanFeatureAccessContext';

/**
 * Plan feature access aligned with subscription tiers.
 *
 * - **Subscribed companies** — limits resolved once from the active plan.
 *
 * @example
 * const { canUse, isAtLimit } = usePlanFeatureAccess();
 * if (canUse(FEATURE_KEYS.CLIENTS) && !isAtLimit(FEATURE_KEYS.CLIENTS, clients.length)) { ... }
 */
export const usePlanFeatureAccess = () => usePlanFeatureAccessContext();

/**
 * Backward-compatible hook for a single feature limit.
 * Prefer `usePlanFeatureAccess()` when checking multiple features on one screen.
 */
export const usePlanFeatureLimit = (featureUniqueKey) => {
	const { getFeatureLimit, isLoading } = usePlanFeatureAccessContext();
	const feature = getFeatureLimit(featureUniqueKey);
	const enforcementOff = feature.isEnforcementActive === false;

	return {
		planName: feature.planName,
		planId: feature.planId,
		rawLimit: feature.rawLimit,
		readableLimit: feature.readableLimit,
		displayLimit: feature.displayLimit,
		numericLimit: enforcementOff ? null : feature.numericLimit,
		isUnlimited: enforcementOff ? true : feature.isUnlimited,
		hasSubscription: feature.hasSubscription,
		isActive: feature.isEnforcementActive !== false,
		isEnforcementActive: feature.isEnforcementActive !== false,
		/** Plan includes this feature (or enforcement is turned off). */
		hasAccess: enforcementOff || Boolean(feature.isAccessible),
		isLoading,
	};
};

export default usePlanFeatureAccess;
